import React, { useEffect, useState } from "react";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { RxPencil1 } from "react-icons/rx";
import { MdDeleteOutline } from "react-icons/md";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";


import {
  useDeleteGoalMutation,
  useGetGoalsQuery,
} from "src/services/GoalServices";
import {
  setIsTableLoading,
  setItems,
  setRowsPerPage,
  setTotalItems,
  setSearchValue,
  setPage,
} from "src/redux/slices/GoalSlice";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";

import { Tooltip } from "@mui/material";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";
import GoalListing from "./GoalListing";
import AddAchievementWrapper from "./Achievements/Add/AddAchievementWrapper";
import EditGoalFormWrapper from "../Edit/EditGoalFormWrapper";
import AddGoalFormWrapper from "../Add/AddGoalFormWrapper";

type Props = {};

const GoalListingWrapper = (props: Props) => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.goal);
  const [isOpenAchivementDialog, setIsOpenAchivementDialog] = useState(false);
  const [isOpenAddForm, setIsOpenAddForm] = useState(false);
  const [isOpenEditFrom, setIsOpenEditForm] = useState(false);
  const [goalId, setGoalId] = useState("");

  const [deleteGoal] = useDeleteGoalMutation();
  const { data, isLoading, isFetching } = useGetGoalsQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["name"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);
  const dispatch = useDispatch();

  const calculateRemainingDays = (deadline: any) => {
    if (!deadline) return "-";
    const currentDate = new Date();
    const deadlineDate = new Date(deadline);

    // Calculate the difference in milliseconds
    const differenceInMs = Number(deadlineDate) - Number(currentDate);

    // Convert milliseconds to days
    const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

    if (differenceInDays > 0) {
      return `${differenceInDays} days left`;
    } else if (differenceInDays === 0) {
      return "Deadline is today";
    } else {
      return "Deadline has passed";
    }
  };

  const getActionOptions = (goalId: string) => {
    return [
      {
        label: (
          <div className="flex items-center gap-2 text-secondary-main">
            <RxPencil1 className="text-lg" /> Edit
          </div>
        ),
        onClick: () => {
          setGoalId(goalId);
          setIsOpenEditForm(true);
        },
        actionName: UserModuleActionTypes.EDIT,
        moduleName: UserModuleNameTypes.GOAL,
      },
      {
        label: (
          <div className="flex items-center gap-2 font-semibold text-red-600">
            <MdDeleteOutline className="text-lg" /> Delete
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to Delete this Assets ?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result?.isConfirmed) {
                deleteGoal(goalId).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
        actionName: UserModuleActionTypes.DELETE,
        moduleName: UserModuleNameTypes.GOAL,
      },
    ];
  };
  const columns: columnTypes[] = [
    {
      field: "goalCategoryName",
      headerName: "Category",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize  min-w-[150px]",
      // name: UserModuleNameTypes.EXPENSES_LIST_AMOUNT,
    },

    {
      field: "name",
      headerName: "Name",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize  min-w-[150px]",
      // name: UserModuleNameTypes.EXPENSES_LIST_AMOUNT,
    },

    {
      field: "type",
      headerName: "Type",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize min-w-[150px]",
      // name: UserModuleNameTypes.EXPENSES_LIST_CATEGORY_NAME,
    },
    {
      field: "target",
      headerName: "Target",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize min-w-[120px]",
      // name: UserModuleNameTypes.EXPENSES_LIST_CATEGORY_NAME,
      renderCell: (row: any) => (
        <div>
          <div className="font-medium text-slate-700">
            {row.target
              ? `${row?.achieved}/${row.target}`
              : `${row.achieved}/100%`}
          </div>
        </div>
      ),
    },
    {
      field: "achieved",
      headerName: "Pending",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize min-w-[120px]",
      // name: UserModuleNameTypes.EXPENSES_LIST_CATEGORY_NAME,
      renderCell: (row: any) => {
        let finalPending = Math.max(
          (row?.target ? row.target : 100) - row.achieved,
          0
        );
        return (
          <div>
            <div className="font-medium text-slate-700">
              {row?.target ? finalPending : `${finalPending}%`}
            </div>
          </div>
        );
      },
    },
    {
      field: "deadline",
      headerName: "Deadline",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize  min-w-[200px]",
      // name: UserModuleNameTypes.EXPENSES_LIST_EXPENSE_DATE,
      renderCell: (row: any) => (
        <div>
          <div className="font-medium text-slate-700">
            {" "}
            {row.deadline ? calculateRemainingDays(row.deadline) : "-"}
          </div>
          <div className="text-xs text-slate-700">
            {row.deadline
              ? formatedDateTimeIntoIst(row.deadline, "DD MMM yyyy")
              : "-"}
          </div>
        </div>
      ),
    },
    {
      field: "accountName",
      headerName: "Members",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize min-w-[250px]",
      // name: UserModuleNameTypes.EXPENSES_LIST_VIEW_BILL,
      renderCell: (row: any) => (
        <div className="text-[12px]">
          {row?.membersInvolved?.length
            ? row?.membersInvolved?.map((el: any, index: any) => {
                return (
                  <Tooltip title={el?.memberName}>
                    <div className="flex flex-col gap-2">
                      {index + 1}. {el?.memberFirstName} {el?.memberLastName}
                    </div>
                  </Tooltip>
                );
              })
            : "-"}
        </div>
      ),
    },
    {
      field: "measuredByName",
      headerName: "Measured By",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize min-w-[150px]",
      // name: UserModuleNameTypes.EXPENSES_LIST_CATEGORY_NAME,
    },
    {
      field: "achievement",
      headerName: "Achievement",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize min-w-[150px]",
      // name: UserModuleNameTypes.EXPENSES_LIST_CATEGORY_NAME,
      renderCell: (row: any) => {
        let isConditionMet = false;
        if (row?.type === "COUNTABLE") {
          isConditionMet = row?.target > row?.achieved;
        } else if (row?.type === "UNCOUNTABLE") {
          isConditionMet = row?.achieved < 100;
        }
        return (
          <div>
            <div className="font-medium text-slate-700 ">
              {isConditionMet && row?.measuredById === userData?.userId ? (
                <ATMLoadingButton
                  onClick={(e: any) => {
                    e.stopPropagation();
                    setIsOpenAchivementDialog(true);
                    setGoalId(row);
                  }}
                >
                  Achievement
                </ATMLoadingButton>
              ) : (
                "-"
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "action",
      flex: "flex-[1_1_0%]",
      extraClasses: "py-2 capitalize min-w-[150px]",
      renderCell: (row: any) => {
        const options = getActionOptions(row?._id);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];

  return (
    <div>
      <GoalListing
        columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.GOAL,
          actionName: UserModuleActionTypes.LIST,
          columns: columns,
        })}
        rows={items}
        getActionOptions={getActionOptions}
        onAddNew={() => {
          setIsOpenAddForm(true);
        }}
        paginationProps={{
          isTableLoading: isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {isOpenAddForm && (
        <AddGoalFormWrapper onClose={() => setIsOpenAddForm(false)} />
      )}
      {isOpenEditFrom && (
        <EditGoalFormWrapper
          goalId={goalId}
          onClose={() => setIsOpenEditForm(false)}
        />
      )}
      {isOpenAchivementDialog && (
        <AddAchievementWrapper
          selectedGoals={goalId}
          onClose={() => setIsOpenAchivementDialog(false)}
        />
      )}
    </div>
  );
};

export default GoalListingWrapper;
